import './MarketIcon.css';const a = "_marketIcon_ca56572", o = "_singleColor_37a48ad", s = "_small_0610760", e = "_medium_d3a00fa", l = "_large_87980e5", t = { marketIcon: a, singleColor: o, small: s, medium: e, large: l };
export {
  t as default
};
